import { useMutation, useQuery, useSubscription } from "@apollo/react-hooks";
import { Button, Card, Empty, message, Progress } from "antd";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import Empty_yourtaskfortheday from "../../../Assets/Images/Empty/Empty_yourtaskfortheday.svg";
import { useHistory } from "react-router-dom";
import { Loader } from "../../../Components/Loader";
import { CancelTaskModal } from "../../../Components/Modals/CancelTaskModal";
import { ViewTutorialModal } from "../../../Components/Modals/ViewTutorialModal/ViewTutorialModal";
import { CustIcon } from "../../../Components/Svgs/Svgs";
import { UPDATE_TASK_STATUS } from "../../../Graphql/mutations";
import { GET_USER_TIMEZONE } from "../../../Graphql/queries";
import {
  GET_USERS_TASKS_LIST,
  GET_USER_WORKING_SHIFT,
} from "../../../Graphql/subscriptions";
import "./TaskForDay.less";
import TaskQrCodeModal from "../../../Components/Drawers/TaskQrCode/TaskQrCodeModal";
import { usePermissionUser } from "../../../Utils/Context/permissionContext";
import PictureRequiredAttachmentDrawer from "../../../Components/Drawers/PictureRequiredAttachment/PictureRequiredAttachment";

const { REACT_APP_ASSETS_URL } = process.env;

export const TaskForDay = ({ userName }) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const { userPermissionAccess: permission } = usePermissionUser();
  const [completePercentage, setCompletePercentage] = useState(0);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [isTutorialModalVisible, setIsTutorialModalVisible] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [tutorialType, setTutorialType] = useState("");
  const [tutorialUrl, setTutorialUrl] = useState("");
  const [currentDateTimeZone, setCurrentDateTimeZone] = useState(
    moment().tz("America/Los_Angeles").format("YYYY-MM-DD")
  );
  const [filteredTaskList, setFilteredTaskList] = useState([]);
  const [allowEODUpdate, setAllowEODUpdate] = useState(null);
  const [userTaskId, setUserTaskId] = useState();
  const [showQrDrawer, setShowQrDrawer] = useState(false);
  const [singleTaskDetails, setSingleTaskDetails] = useState(undefined);

  const [
    isPictureRequiredAttachmentVisible,
    setIsPictureRequiredAttachmentVisible,
  ] = useState(false);

  const { data: userData, loading: userDataLoading } = useQuery(
    GET_USER_TIMEZONE,
    { variables: { user_id: localStorage.getItem("user_id") } }
  );

  const { data: userShift, loading: isUserShiftLoading } = useSubscription(
    GET_USER_WORKING_SHIFT,
    {
      variables: {
        user_id: localStorage.getItem("user_id"),
        working_day: moment()
          .tz(userData?.getUsersById?.time_zone)
          ?.format("dddd"),
      },
      shouldResubscribe: true,
      skip: userDataLoading,
      fetchPolicy: "cache-and-network",
    }
  );

  const { data: userTasksData, loading: isUserTasksDataLoading } =
    useSubscription(GET_USERS_TASKS_LIST, {
      variables: {
        user_id: localStorage.getItem("user_id"),
        todaysDate: moment()
          .tz(userData?.getUsersById?.time_zone)
          ?.format("YYYY-MM-DD"),
      },
      shouldResubscribe: true,
      skip: userDataLoading,
      fetchPolicy: "cache-and-network",
    });

  const [UPDATE_TASK_STATUS_MUTATION, { loading: isUpdatingTask }] =
    useMutation(UPDATE_TASK_STATUS);

  useEffect(() => {
    if (userData) {
      setCurrentDateTimeZone(
        moment().tz(userData?.getUsersById?.time_zone)?.format("YYYY-MM-DD")
      );
    }
  }, [userData]);

  useEffect(() => {
    if (userTasksData && userShift) {
      calculateEndOfShiftTime();
    }
  }, [userTasksData, userShift]);

  useEffect(() => {
    if (userTasksData && userShift) {
      formatTasks();
    }
  }, [userTasksData, userShift, allowEODUpdate]);

  const formatTasks = async () => {
    userTasksData?.user_tasks_map.forEach((singleTask) => {
      switch (singleTask.task.taskType.type) {
        default:
        case "reminder":
          singleTask.tagClass = "blueTag";
          singleTask.taskType = "Reminder";
          break;
        case "time_sensitive":
          singleTask.tagClass = "redTag";
          singleTask.taskType = "Time Sensitive";
          break;
        case "end_of_day":
          singleTask.tagClass = "orangeTag";
          singleTask.taskType = "End of Day";
          break;
        case "during_day":
          singleTask.tagClass = "greenTag";
          singleTask.taskType = "During Day";
          break;
      }
      switch (singleTask.task_status) {
        default:
        case "pending":
          if (
            singleTask.task.taskType.type === "end_of_day" &&
            !allowEODUpdate
          ) {
            singleTask.showOptions = false;
          } else {
            singleTask.showOptions = true;
          }
          singleTask.cardClass = "whiteCard";
          break;
        case "completed":
          singleTask.showOptions = false;
          singleTask.cardClass = "taskCompleted";
          break;
        case "incomplete":
          singleTask.showOptions = false;
          singleTask.cardClass = "taskIncomplete";
          break;
        case "escalated":
          singleTask.showOptions = false;
          singleTask.cardClass = "taskEscalated";
          break;
      }
    });
    if (userTasksData?.user_tasks_map.length > 0) {
      let pendingTasksCount = userTasksData?.user_tasks_map.filter(
        (x) => x.task_status === "pending"
      ).length;
      setCompletePercentage(
        parseInt(
          100 - (pendingTasksCount / userTasksData?.user_tasks_map.length) * 100
        )
      );
    } else {
      setCompletePercentage(100);
    }
    let taskList = [];
    let pendingTasks = userTasksData.user_tasks_map.filter(
      (x) => x.task_status === "pending"
    );
    taskList.push(
      ...pendingTasks.filter((p) => p.task.taskType.type === "time_sensitive"),
      ...pendingTasks.filter((p) => p.task.taskType.type === "reminder"),
      ...pendingTasks.filter((p) => p.task.taskType.type === "during_day"),
      ...pendingTasks.filter((p) => p.task.taskType.type === "end_of_day")
    );
    let incompleteTasks = userTasksData.user_tasks_map.filter(
      (x) => x.task_status === "incomplete"
    );
    taskList.push(
      ...incompleteTasks.filter(
        (p) => p.task.taskType.type === "time_sensitive"
      ),
      ...incompleteTasks.filter((p) => p.task.taskType.type === "reminder"),
      ...incompleteTasks.filter((p) => p.task.taskType.type === "during_day"),
      ...incompleteTasks.filter((p) => p.task.taskType.type === "end_of_day")
    );
    let escalatedTasks = userTasksData.user_tasks_map.filter(
      (x) => x.task_status === "escalated"
    );
    taskList.push(
      ...escalatedTasks.filter(
        (p) => p.task.taskType.type === "time_sensitive"
      ),
      ...escalatedTasks.filter((p) => p.task.taskType.type === "reminder"),
      ...escalatedTasks.filter((p) => p.task.taskType.type === "during_day"),
      ...escalatedTasks.filter((p) => p.task.taskType.type === "end_of_day")
    );
    let completedTasks = userTasksData.user_tasks_map.filter(
      (x) => x.task_status === "completed"
    );
    taskList.push(
      ...completedTasks.filter(
        (p) => p.task.taskType.type === "time_sensitive"
      ),
      ...completedTasks.filter((p) => p.task.taskType.type === "reminder"),
      ...completedTasks.filter((p) => p.task.taskType.type === "during_day"),
      ...completedTasks.filter((p) => p.task.taskType.type === "end_of_day")
    );
    setFilteredTaskList(taskList);
    setIsLoading(false);
  };

  const calculateEndOfShiftTime = () => {
    if (!userShift.user_shift_by_pk) {
      setAllowEODUpdate(false);
      return true;
    }
    let duration = moment
      .tz(
        userShift.user_shift_by_pk.end_time,
        "HH:mm:ss",
        userData?.getUsersById?.time_zone
      )
      .diff(
        moment.tz(
          userShift.user_shift_by_pk.start_time,
          "HH:mm:ss",
          userData?.getUsersById?.time_zone
        ),
        "seconds"
      );
    let eod_duration = (duration * 90) / 100;
    // let eod_time = moment
    //   .tz(
    //     userShift.user_shift_by_pk.start_time,
    //     "HH:mm:ss",
    //     userData?.getUsersById?.time_zone
    //   )
    //   .add(eod_duration, "seconds");
    let end_time_limit = 1800; //half an hour in seconds
    let eod_time = moment
      .tz(
        userShift.user_shift_by_pk.end_time,
        "HH:mm:ss",
        userData?.getUsersById?.time_zone
      )
      .subtract(end_time_limit, "seconds");
    if (moment.tz(userData?.getUsersById?.time_zone).isAfter(eod_time)) {
      setAllowEODUpdate(true);
    } else {
      setAllowEODUpdate(false);
    }
    return true;
  };

  const handleCancelTask = (task_id) => {
    setIsCancelModalVisible(true);
    setTaskId(task_id);
  };

  const handleCompleteTask = async (taskId, details) => {
    if (details.task.user_tasks_maps[0]?.required_attachment) {
      setIsPictureRequiredAttachmentVisible(true);
      setSingleTaskDetails(details);
    } else {
      try {
        const isUpdateSuccessful = await UPDATE_TASK_STATUS_MUTATION({
          variables: {
            user_id: localStorage.getItem("user_id"),
            task_id: taskId,
            task_status: "completed",
          },
        });
        if (!isUpdateSuccessful.errors) {
          message.success("Task Updated Successfully");
          setIsCancelModalVisible(false);
        } else {
          message.error("Something went wrong...");
        }
      } catch (error) {}
    }
  };

  const handleTutorial = ({ tutorial_type: type, tutorial_url: url }) => {
    setTutorialType(type);
    setTutorialUrl(REACT_APP_ASSETS_URL + url);
    setIsTutorialModalVisible(true);
  };

  return (
    <section className="taskForDaySec">
      {!history.location.pathname.includes("my-tasks") && (
        <div className="secSubTitle">
          <div className="stLeft">
            <h5>Your tasks for the day</h5>
          </div>
          <div className="stright">
            <small
              className="cursor-pointer"
              onClick={() => history.push("/tasks/my-tasks")}
            >
              Show more
            </small>
          </div>
        </div>
      )}

      <div className="task_blk">
        <Card className="taskCard">
          <div className="d-flex justify-content-between align-align-items-lg-start">
            <div className="user">
              <h3>Hi, {userName.split(" ")[0] + "!"}</h3>
              <h4>
                You've got {userTasksData?.user_tasks_map.length || "no"} task
                today.
              </h4>
            </div>
            <div className="taskForDayPrograss">
              <Progress
                type="circle"
                className="w-100"
                width="100%"
                percent={completePercentage}
              />
            </div>
          </div>
          <ul className="list-inline taskForDayList">
            {isUserTasksDataLoading && isLoading ? (
              <Loader />
            ) : userTasksData && filteredTaskList.length === 0 ? (
              <Empty
                image={Empty_yourtaskfortheday}
                description={
                  <span>
                    Welcome, Sit back and relax! You'll see your assigned tasks
                    once your manager updates them!
                  </span>
                }
              />
            ) : (
              filteredTaskList.map((singleTasks, index) => {
                return (
                  <li key={index} className="d-flex flex-column myTaskForDay">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="">
                        <div className={`tags ${singleTasks.tagClass}`}>
                          {singleTasks.taskType}
                        </div>
                      </div>
                      <div
                        className={`taskAction d-flex align-items-center ${singleTasks.task_status}`}
                      >
                        {singleTasks?.showOptions ? (
                          <Fragment>
                            {singleTasks.task.task_tutorial_maps.length !==
                              0 && (
                              <Button
                                type="link"
                                onClick={() =>
                                  handleTutorial(
                                    singleTasks.task.task_tutorial_maps[0]
                                      .tutorial
                                  )
                                }
                                className="d-inline-flex align-items-center viewTutorial #0D6FB7"
                              >
                                <CustIcon type="tutorial" className="mr-2" />
                                <span>View tutorial</span>
                              </Button>
                            )}
                            <Button
                              loading={isUpdatingTask}
                              type="link"
                              onClick={() =>
                                handleCompleteTask(
                                  singleTasks.task.task_id,
                                  singleTasks
                                )
                              }
                              className="d-inline-flex ml-3 true #0D6FB7"
                            >
                              <CustIcon type="chack" />
                            </Button>
                            <Button
                              type="link"
                              onClick={() =>
                                handleCancelTask(singleTasks.task.task_id)
                              }
                              className="d-inline-flex ml-3 false #0D6FB7"
                            >
                              <CustIcon type="close-o" />
                            </Button>
                          </Fragment>
                        ) : (
                          <p>
                            {singleTasks.task_status.charAt(0).toUpperCase() +
                              singleTasks.task_status.slice(1)}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="myTaskforDayDetails">
                      <span>{singleTasks.task.description}</span>
                      {/* <strong>Read More</strong> */}
                    </div>
                    {!!singleTasks?.user_task_id && (
                      <div className=" d-flex">
                        <div className="ml-auto pt-2">
                          <div
                            className="viewDetails"
                            onClick={() => {
                              setUserTaskId(singleTasks?.user_task_id);
                              setShowQrDrawer(true);
                            }}
                          >
                            View Details
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                );
              })
            )}
          </ul>
        </Card>
      </div>
      <ViewTutorialModal
        type={tutorialType}
        src={tutorialUrl}
        visible={isTutorialModalVisible}
        onCancel={() => {
          setTutorialType("");
          setTutorialUrl("");
          setIsTutorialModalVisible(false);
        }}
      />
      <CancelTaskModal
        visible={isCancelModalVisible}
        onCancel={() => setIsCancelModalVisible(false)}
        taskId={taskId}
      />

      {showQrDrawer && (
        <TaskQrCodeModal
          userPermission={permission.allow_qr_code}
          userTaskId={userTaskId}
          showQrDrawer={showQrDrawer}
          setShowQrDrawer={setShowQrDrawer}
        />
      )}

      {isPictureRequiredAttachmentVisible && (
        <PictureRequiredAttachmentDrawer
          isPictureRequiredAttachmentVisible={
            isPictureRequiredAttachmentVisible
          }
          setIsPictureRequiredAttachmentVisible={
            setIsPictureRequiredAttachmentVisible
          }
          setSingleTaskDetails={setSingleTaskDetails}
          singleTaskDetails={singleTaskDetails}
        />
      )}
    </section>
  );
};
